import styled, { css } from 'styled-components';
import { breakpoints } from 'themes/global';
import { convertHexToRGBA } from 'utils/convertHexToRgba';

export const Wrapper = styled.main`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    max-width: 1320px;
    padding: 0 ${theme.spacing.xxxs};
  `}
`;

export const ImageBox = styled.picture`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 350px;
    min-width: 350px;
    width: 100%;
    flex: 1;
    padding: ${theme.spacing.sm};
    border-radius: ${theme.spacing.xxs};
    background-color: ${convertHexToRGBA(
      theme.color.primary.light,
      theme.opacity.semitransparent
    )};

    svg {
      width: 100%;
      height: 100%;
    }
  `}
`;

export const TextBox = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    flex: none;
    flex-direction: column;
    text-align: left;
    color: #ffff;
    margin-top: ${theme.spacing.sm};
    font-size: ${theme.spacing.sm};
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    flex: 1;
    max-width: 434px;
    margin-top: ${theme.spacing.sm};

    img {
      width: 100%;
      height: auto;
    }

    @media (min-width: ${breakpoints.md}) {
      flex-direction: row-reverse;

      ${TextBox} {
        margin-right: ${theme.spacing.sm};
        max-width: 410px;
        margin-top: 0;
      }
    }

    @media (min-width: ${breakpoints.lg}) {
      ${TextBox} {
        margin-right: 100px;
      }
    }
  `}
`;

export const TitleBox = styled.div`
  ${({ theme }) => css`
    margin: ${theme.spacing.xs} 0 ${theme.spacing.xxs};
    font-size: ${theme.font.size.xs};
  `}
`;

export const SubtitleBox = styled.div`
  ${({ theme }) => css`
    margin: ${theme.spacing.xs} 0;
    font-size: ${theme.font.size.xs};
  `}
`;

export const ErrorCodeBox = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.spacing.sm};
    font-size: ${theme.font.size.xxs};
    opacity: 0.6;
  `}
`;
